import React from 'react';

const CartModal = ({ items, onClose, onUpdateQty, onRemoveItem, onCheckout }) => {
  const subtotal = items.reduce((sum, it) => sum + (it.quantity * (it.unit_price || 0)), 0);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4" onClick={onClose}>
      <div 
        className="bg-white rounded-2xl max-w-lg w-full max-h-[90vh] flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-xl font-bold bengali-text">ঝুড়ি</h2>
          <button onClick={onClose} className="text-slate-500 hover:text-slate-700">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {items.length === 0 ? (
            <div className="text-center text-slate-500 bengali-text py-8">ঝুড়ি খালি</div>
          ) : (
            items.map((it) => (
              <div key={it.product_id} className="flex items-center gap-3 p-3 border rounded-xl">
                {it.image && (
                  <img src={it.image} alt={it.name_bn} className="w-14 h-14 rounded-lg object-cover border" />
                )}
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-slate-900 truncate bengali-text">{it.name_bn}</div>
                  <div className="text-sm text-slate-600">৳{(it.unit_price || 0).toFixed(2)} × {it.quantity}</div>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    aria-label="Decrease"
                    onClick={() => onUpdateQty(it.product_id, Math.max(1, it.quantity - 1))}
                    className="w-8 h-8 rounded-lg border flex items-center justify-center hover:bg-slate-50"
                  >
                    –
                  </button>
                  <div className="w-8 text-center font-semibold">{it.quantity}</div>
                  <button
                    aria-label="Increase"
                    onClick={() => onUpdateQty(it.product_id, it.quantity + 1)}
                    className="w-8 h-8 rounded-lg border flex items-center justify-center hover:bg-slate-50"
                  >
                    +
                  </button>
                  <button
                    aria-label="Remove"
                    onClick={() => onRemoveItem(it.product_id)}
                    className="ml-2 text-red-600 hover:text-red-700"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <div className="border-t p-4 space-y-3 bg-slate-50 rounded-b-2xl">
          <div className="flex justify-between text-sm">
            <span className="text-slate-600 bengali-text">সাবটোটাল</span>
            <span className="font-semibold">৳{subtotal.toFixed(2)}</span>
          </div>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-3 rounded-lg border-2 border-slate-300 text-slate-700 hover:bg-slate-100 font-semibold transition-colors bengali-text"
            >
              আরো যোগ করুন
            </button>
            <button
              disabled={items.length === 0}
              onClick={() => onCheckout()}
              className={`flex-1 px-6 py-3 rounded-lg text-white font-semibold transition-colors bengali-text ${
                items.length === 0 ? 'bg-slate-300 cursor-not-allowed' : 'bg-orange-600 hover:bg-orange-700'
              }`}
            >
              চেকআউট
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartModal;


